import React, { useEffect, useState } from 'react'

import styled from 'styled-components'

import Box from 'app/components/design-system-components/Box'
import { Button } from 'app/components/design-system-components/Button'
import Flex from 'app/components/design-system-components/Flex'
import { Text } from 'app/components/design-system-components/typography'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

const SelectGroupStyle = styled(Box)`
  margin-bottom: 24px;
`

const SelectButtonStyle = styled(Button)`
  margin-right: 8px;
`

const ConnectedButtonGroupStyle = styled(Flex)`
  border: 1px solid ${theme.colors.gray400};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${theme.colors.white};
`

const ConnectedButtonStyle = styled(Button)`
  flex: 1;
  border: none;
  border-radius: 0;
  margin: 0;
  width: 160px;
  height: 50px;
  border-right: ${(props) =>
    props.showRightBorder ? `1px solid ${theme.colors.gray400}` : 'none'};
`

export const ButtonSelectGroup = ({
  selected, // default selected id
  onChange,
  selectedVariant = 'outlineGreen',
  defaultVariant = 'outlineGray',
  options = [],
  label,
  useConnectedStyle = false,
  connectedSelectedVariant = '', // Variant for selected button in connected style
  connectedUnselectedVariant = 'whiteBGGrayBorder', // Variant for unselected button in connected style
  maxWidth,
}) => {
  const [groupOptions, setGroupOptions] = useState([])

  useEffect(() => {
    const mappedOptions = options.map((option) => {
      const isSelected = option.optionMeta.id === selected

      const variantIfSelected =
        option.optionMeta.selectedVariant || selectedVariant
      const variantIfNotSelected =
        option.optionMeta.notSelectedVariant || defaultVariant

      return {
        ...option,
        optionMeta: {
          ...option.optionMeta,
          isSelected: isSelected,
          variant: isSelected ? variantIfSelected : variantIfNotSelected,
        },
      }
    })

    setGroupOptions(mappedOptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  const selectOption = (select, event) => {
    selected = select.option
    onChange(select, event)
  }

  const renderOptions = () => {
    if (useConnectedStyle) {
      return (
        <ConnectedButtonGroupStyle maxWidth={maxWidth}>
          {groupOptions.map((option, index) => {
            const isLastButton = index === groupOptions.length - 1
            const variant = option.optionMeta.isSelected
              ? connectedSelectedVariant
              : connectedUnselectedVariant

            return (
              <ConnectedButtonStyle
                key={option.optionMeta.id}
                variant={variant}
                showRightBorder={!isLastButton}
                onClick={(event) => selectOption(option, event)}
              >
                {option.option}
              </ConnectedButtonStyle>
            )
          })}
        </ConnectedButtonGroupStyle>
      )
    }

    return (
      <Flex>
        {groupOptions.map((option) => {
          return (
            <SelectButtonStyle
              flex="1 1 0px"
              key={option.optionMeta.id}
              variant={option.optionMeta.variant}
              onClick={(event) => selectOption(option, event)}
            >
              {option.option}
            </SelectButtonStyle>
          )
        })}
      </Flex>
    )
  }

  const optionsElement = renderOptions()

  return (
    <SelectGroupStyle>
      {label && (
        <Box>
          <Text
            fontSize={theme.fontSizes[5] + 'px'}
            fontWeight={theme.fontWeights[3]}
            mb={5}
          >
            {label}
          </Text>
        </Box>
      )}

      {optionsElement}
    </SelectGroupStyle>
  )
}
